/**
 * Returns the base path prefix for the current deployment.
 *
 * In ephemeral environments the app is served under a path like
 * `/frontend-123`, so every hard navigation (`window.location.href`)
 * must include this prefix. React Router handles it via `basename`,
 * but code that sets `window.location` directly needs this helper.
 */
export function getBasePath(): string {
    const publicUrlBase = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
    if (publicUrlBase) return publicUrlBase;

    if (typeof window !== 'undefined') {
        const match = window.location.pathname.match(/^\/frontend-[^/]+/);
        if (match) return match[0];
    }

    return '';
}

/**
 * Resolves the full path to a static asset under the deployment prefix.
 *
 * @example assetPath('/SLAILOGO.png')  // → "/frontend-123/SLAILOGO.png"
 * @example assetPath('/icons/mic.png') // → "/frontend-123/icons/mic.png"
 */
export function assetPath(asset: string): string {
    return `${getBasePath()}${asset}`;
}
